import BaseAppContainer from "../base--app-container/BaseAppContainer";
import LeftPanelMenu from "../left-panel-menu/LeftPanelMenu";
import Signin from "../sign-in/Signin";
import Styles from "./Messages.module.scss";
import MyImage from "../../res/images/me.png"
import { APP_KEY_IDS } from "../../constants/constants";
import MessageWindow from "./messsage-window/MessageWindow";
import { useContext,  useState } from "react";

//Firebase
import {  signInWithPopup, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { auth, facebookAuthProvider,  googleAuthProvider } from "../../useFirebaseInit";
import { AuthContext } from "../../contexts/AuthContext";
import { AppContext } from "../../contexts/AppContext";




const Messages = () => {

    const {isMobile} = useContext(AppContext)

    const { userId, isLoggedIn } = useContext(AuthContext)

    const [activeOption, setActiveOption] = useState("0")

    const [profileDetails, setPrrofileDetails] = useState({
        id: "0",
        label: "Priyansh Datyal",
        icon: MyImage
    })

    const leftMenu = [
        {
            id: "0",
            label: "Priyansh Datyal",
            subLabel: "Hello1 i forgot to text you but i will make sure this bnuzdkb skjbndfibsiub skzuhfviushf iuoszhedfgiuhb bnzseidfgbh",
            icon: MyImage
        }
    ]

    const onSuccessfulSubmission = (data: any) => {
        setPrrofileDetails(data)
    }

    const signinwithgoogle = async () => {
        signInWithPopup(auth, googleAuthProvider)
            .then((result) => {
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential?.accessToken;
                const user = result.user;
                if (user.uid) {
                    // setUser(user)
                }
            }).catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                const email = error.customData.email;
                const credential = GoogleAuthProvider.credentialFromError(error);
            });

    };

    const signinwithfacebook = () => {
        signInWithPopup(auth, facebookAuthProvider)
            .then((result) => {
                const user = result.user;
                const credential = FacebookAuthProvider.credentialFromResult(result);
                if (credential) {
                    const accessToken = credential.accessToken;
                }
            })
            .catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = FacebookAuthProvider.credentialFromError(error);

                // ...
            });

    }

    return (
        <BaseAppContainer
            appId={APP_KEY_IDS.MESSAGES}
            loadFromX={30}
            width={900}
            height={600}
            title={isMobile ? "Messages" : "iMessage"}
            SideBar={<LeftPanelMenu specialTheme="iMessage" menuContent={isLoggedIn ? leftMenu : []} activeValue={activeOption} handleOptionClick={setActiveOption} onSuccessfulSubmission={onSuccessfulSubmission} />}
            MainScreen={
                <div className={Styles.container} style={{ flexWrap: "wrap" }}>
                    {
                        userId
                            ? <MessageWindow  profileDetails={profileDetails} />
                            : <Signin />
                    }

                </div>}
        />
    )
}

export default Messages
